import { Routes } from '@angular/router';
import { authGuard } from './shell/auth/auth.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: 'login',
    loadComponent: () => import('./shell/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./shell/privacy-policy/privacy-policy.page').then((m) => m.PrivacyPolicyPage),
  },
  {
    path: 'ui-kit',
    loadChildren: () => import('./ui-kit/ui-kit.routes').then((m) => m.UI_KIT_ROUTES),
  },
  {
    path: 'shell/persona',
    canActivate: [authGuard],
    loadComponent: () => import('./shell/persona/persona.page').then((m) => m.PersonaPage),
  },
  {
    path: 'occupant',
    loadChildren: () => import('./occupant/occupant.routes').then((m) => m.OCCUPANT_ROUTES),
  },
  {
    path: 'services',
    loadChildren: () => import('./services/services.routes').then((m) => m.SERVICES_ROUTES),
  },
  { path: '**', redirectTo: 'login' },
];
